export default "__VITE_ASSET__C4WY0IPr__"